module.exports = __webpack_public_path__ + "static/media/footer_linkedin.14e7da65.svg";